module.exports = __webpack_public_path__ + "static/media/music_sprite.8a28f11.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/music_sprite.mp3
// module id = 140
// module chunks = 1